import { ReactNode } from 'react';

import { Skeleton, Box, tokens } from '@cast/design-system';

import type { BoxProps } from '@cast/design-system';

type Props = {
  description: ReactNode;
  controls: ReactNode;
  isLoading?: boolean;
} & BoxProps;

export const InlineWithDescription = ({
  description,
  controls,
  isLoading,
  ...stackProps
}: Props) => {
  return (
    <Box
      className="FormRow-root"
      display="grid"
      gridTemplateColumns="276px auto"
      gap={60}
      py={22}
      borderBottom="1px solid"
      borderColor={tokens.theme.border.structural.neutralSubtle}
      {...stackProps}
    >
      {description}
      {isLoading ? <Skeleton height={35} /> : controls}
    </Box>
  );
};
